import { render, staticRenderFns } from "./SendRenown.vue?vue&type=template&id=de7a06d2&scoped=true&"
import script from "./SendRenown.vue?vue&type=script&lang=js&"
export * from "./SendRenown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7a06d2",
  null
  
)

export default component.exports